import React, { useState, useEffect } from "react";
import { Modal, Form, Row, Col, Select, Input, message } from "antd";

import { FormComponentProps } from "antd/lib/form";
import { IHability, IHabilityType } from "./types";
import { saveOrUpdate, select } from "../actions/dimensionsAndType";
import { Utilitaries } from "../../../business";
const { Option } = Select;

interface IProps extends FormComponentProps {
    record?: IHability;
    onClose: (reload?: boolean) => void;
}

function FormHability({ onClose, record, form }: IProps) {
    const [isSaving, setIsSaving] = useState(false);
    const [habilityTypeList, setHabilityTypeList] = useState<IHabilityType[]>(() => {
        if (record) {
            return [
                {
                    id_tipo_habilidade: record.id_tipo_habilidade,
                    designacao: record.tipo_habilidade,
                    _eliminado_: "t",
                    descricao: "",
                    versao: "",
                },
            ];
        }
        return [];
    });
    const [loadingTypes, setLoadingTypes] = useState(true);

    useEffect(() => {
        select({
            accao: "lista",
            lista: "tipos_habilidades",
            pagina: 1,
            resultados_pagina: 0,
        })
            .then((response) => {
                const list: IHabilityType[] = Utilitaries.toArray(response.linha);
                const data = list.map((item) => ({
                    ...item,
                    designacao: typeof item.designacao === "object" ? "" : item.designacao,
                    descricao: typeof item.descricao === "object" ? "" : item.descricao,
                }));
                setHabilityTypeList(data);
                setLoadingTypes(false);
            })
            .catch(() => {
                message.error("Erro ao carregar os tipos de habilidades");
                onClose();
            });
    }, [onClose]);

    function handleOk() {
        form.validateFields((err, values) => {
            if (!err) {
                setIsSaving(true);

                const objToSave = record
                    ? {
                          id_habilidade: record.id_habilidade,
                          activo: true,
                          versao: record.versao !== "" ? record.versao + 1 : 1,
                      }
                    : {
                          versao: 1,
                      };

                const data = JSON.stringify({
                    habilidade: {
                        ...values,
                        ...objToSave,
                        activo: true,
                    },
                });

                saveOrUpdate({
                    accao: "guardar",
                    formulario: "qa_habilidades.xml",
                    dados: data,
                })
                    .then((sucess) => {
                        if (sucess) {
                            message.success("Guardado");
                            onClose(true);
                        } else {
                            message.error("Ocorreu um erro");
                            setIsSaving(false);
                        }
                    })
                    .catch(() => {
                        message.error("Ocorreu um erro");
                        setIsSaving(false);
                    });
            }
        });
    }

    const { getFieldDecorator } = form;
    const title = record ? "Editar habilidade" : "Nova habilidade";
    return (
        <Modal title={title} visible onCancel={() => onClose()} onOk={handleOk} width="50%" confirmLoading={isSaving}>
            <Form layout="vertical">
                <Row gutter={18}>
                    <Col xs={24} sm={24} md={24}>
                        <Form.Item label="Tipo de habilidade">
                            {getFieldDecorator("tipo_habilidade", {
                                initialValue: record?.id_tipo_habilidade,
                                rules: [
                                    {
                                        required: true,
                                        message: "Campo obrigatório",
                                    },
                                ],
                            })(
                                <Select
                                    showSearch
                                    allowClear
                                    loading={loadingTypes}
                                    optionFilterProp="children"
                                    filterOption={(input, option) => {
                                        if (option.props.children === undefined || option.props.children === null) {
                                            return false;
                                        }

                                        return (
                                            option.props.children
                                                .toString()
                                                ?.toLowerCase()
                                                .indexOf(input.toLowerCase()) >= 0
                                        );
                                    }}
                                >
                                    {habilityTypeList.map((item) => (
                                        <Option key={item.id_tipo_habilidade}>{item.designacao}</Option>
                                    ))}
                                </Select>
                            )}
                        </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={24}>
                        <Form.Item label="Habilidade">
                            {getFieldDecorator("designacao", {
                                initialValue: record?.designacao,
                                rules: [
                                    {
                                        required: true,
                                        message: "Campo obrigatório",
                                    },
                                ],
                            })(<Input />)}
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </Modal>
    );
}

export const WrappedFormHability = Form.create<IProps>({
    name: "form_Hability",
})(FormHability);
